// Copyright 2020 Prescryptive Health, Inc.

import { BusyDispatch } from './busy.dispatch';
import { busyPushAction } from '../actions/busy-push.action';

export const busyPushDispatch = (dispatch: BusyDispatch): void => {
  dispatch(busyPushAction());
};
